import { graphql } from "relay-runtime"

export const chSickLeaveFragment = graphql`
  fragment chSickLeaveFragment on ch_SickLeave {
    id
    language
    fileId
    progressNoteId
    certificateType
    from
    to
    reason
    workCapacity
    workCapacityType
    employerName
    additionalInformation
    signedAt
    signedBy
    updatedAt
    updatedBy
    createdAt
    createdBy
    followUpId
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
